var global = require('../internals/global');
var isObject = require('../internals/is-object');

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/document-create-element.js
// module id = 249
// module chunks = 0